module.exports = __webpack_public_path__ + "static/media/29FUNOV12.44a602e3.jpg";